module.exports = __webpack_public_path__ + "dist/img/license.6a2d0f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/license.jpg
// module id = JC4d
// module chunks = 1